import * as React from 'react';
import { cn } from '@/lib/utils';
import * as Icons from 'lucide-react';

export function ModuleHeader({
  title,
  description,
  icon,
  metrics,
  actions,
  className,
}) {
  const Icon = icon ? Icons[icon] : null;

  return (
    <div className={cn('space-y-4 mb-6', className)}>
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <div className="flex items-center gap-3">
            {Icon && <Icon className="h-6 w-6 text-primary" />}
            <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
          </div>
          {description && (
            <p className="text-muted-foreground">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {metrics && (
        <div className="flex flex-wrap items-center gap-4">
          {metrics.map((metric, idx) => (
            <div key={idx} className="flex items-center gap-2">
              {metric.icon && (
                <metric.icon className="h-4 w-4 text-muted-foreground" />
              )}
              <span className="text-sm font-medium">{metric.label}:</span>
              <span className="text-sm font-bold data-text">{metric.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function EmptyState({ icon, title, description, action, className }) {
  const Icon = icon ? Icons[icon] : Icons.Inbox;

  return (
    <div className={cn(
      'flex flex-col items-center justify-center py-12 text-center space-y-4 motion-enter',
      className
    )}>
      <div className="rounded-full bg-muted p-6">
        <Icon className="h-12 w-12 text-muted-foreground" />
      </div>
      <div className="space-y-2">
        <h3 className="text-lg font-semibold">{title}</h3>
        {description && (
          <p className="text-sm text-muted-foreground max-w-md">{description}</p>
        )}
      </div>
      {action && <div className="pt-2">{action}</div>}
    </div>
  );
}